import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=90c2d292&scoped=true&"
import script from "./notificationList.ts?vue&type=script&lang=ts&"
export * from "./notificationList.ts?vue&type=script&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=90c2d292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2d292",
  null
  
)

export default component.exports